import { AiOutlineRight } from "react-icons/ai";
import PropTypes from "prop-types";

const UpIcon = ({ onClick, size, sx, className }) => {
  return (
    <AiOutlineRight
      className={`icon ${className}`}
      size={size}
      onClick={onClick}
      style={sx}
    />
  );
};

UpIcon.defaultProps = {
  size: 30,
  onClick: () => {},
  sx: {},
  className: "",
};

UpIcon.propTypes = {
  onClick: PropTypes.func,
  size: PropTypes.number,
  sx: PropTypes.object,
  className: PropTypes.string,
};
export default UpIcon;
